module.exports = __webpack_public_path__ + "img/linux.0c1f8b2b.svg";